"use client";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";
import "./SimpleFromDayOneSection.css";

export default function SimpleFromDayOneSection() {
  const { t } = useTranslation("landingPage");
  const [activeTab, setActiveTab] = useState("doctors");

  useRevealOnScroll([activeTab]);

  const tabsRaw = t("simple.tabs", { returnObjects: true });
  const stepsRaw = t("simple.steps", { returnObjects: true });

  const safeTabs = Array.isArray(tabsRaw) ? tabsRaw : [];
  const safeSteps =
    stepsRaw && typeof stepsRaw === "object" ? stepsRaw : {};

  const activeSteps = Array.isArray(safeSteps[activeTab])
    ? safeSteps[activeTab]
    : [];

  if (!safeTabs.length || !activeSteps.length) {
    return null;
  }

  const left = activeSteps.filter((_, i) => i % 2 === 0 && i !== 4);
  const right = activeSteps.filter((_, i) => i % 2 === 1);
  const last = activeSteps[4];

  return (
    <section className="sfdo">
      <div className="sfdo__container">
        {/* Header */}
        <div className="sfdo__header reveal-on-scroll reveal-up">
          <p className="sfdo__eyebrow">
            {t("simple.label")}
          </p>

          <h2 className="sfdo__title">
            <span className="sfdo__title-highlight">
              {t("simple.title.accent")}
            </span>{" "}
            {t("simple.title.rest")}
          </h2>

          <p className="sfdo__subtitle">
            {t("simple.subtitle")}
          </p>
        </div>

        {/* Tabs */}
        <div className="sfdo__tabs reveal-on-scroll reveal-scale">
          {safeTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`sfdo__tab${
                activeTab === tab.key ? " sfdo__tab--active" : ""
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Steps grid */}
        <div className="sfdo__grid" key={activeTab}>
          <div className="sfdo__col">
            {left.map((step, i) => (
              <StepCard
                key={`${activeTab}-left-${i}`}
                step={step}
                delay={i * 100}
              />
            ))}
          </div>

          <div className="sfdo__col sfdo__col--offset">
            {right.map((step, i) => (
              <StepCard
                key={`${activeTab}-right-${i}`}
                step={step}
                delay={(i + 2) * 100}
              />
            ))}
          </div>
        </div>

        {/* Step 05 */}
        {last && (
          <div className="sfdo__last-row">
            <StepCard
              key={`${activeTab}-last`}
              step={last}
              delay={420}
            />
          </div>
        )}
      </div>
    </section>
  );
}

function StepCard({ step, delay = 0 }) {
  if (!step) return null;

  return (
    <div
      className="sfdo__step reveal-on-scroll reveal-card"
      style={{ transitionDelay: `${delay}ms` }}
    >
      <span className="sfdo__step-number">
        {step.number}
      </span>

      <h3 className="sfdo__step-title">
        {step.title}
      </h3>

      <p className="sfdo__step-desc">
        {step.desc}
      </p>

      <p className="sfdo__step-highlight">
        {step.highlight}
      </p>
    </div>
  );
}